import { Box, Typography } from "@mui/material";
import { CSSProperties, ReactNode } from "react";

interface Props {
  component?: "p" | "span";
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  textColor?: string;
  dangerouslySetInnerHTML?: { __html: string };
  bold?: boolean;
}

const Text = ({
  children,
  component = "p",
  className,
  style,
  textColor,
  dangerouslySetInnerHTML,
  bold = false,
}: Props) => {
  const html = dangerouslySetInnerHTML ?? (typeof children === 'string' ? { __html: children } : null);
  return (
    <Box className={`Text ${className} ${bold && 'bold'}`} sx={style}>
      {html
        ? <Typography textAlign="center" component={component} sx={{ color: textColor }} dangerouslySetInnerHTML={html} />
        : <Typography textAlign="center" component={component} sx={{ color: textColor }}>{children}</Typography>
      }
    </Box>
  );
};

export default Text;
